import React from 'react';
import { BiFilter } from 'react-icons/bi';
import { CogIcon } from '@heroicons/react/outline';
import { BsLayoutThreeColumns } from 'react-icons/bs';
import TableDefaultFilter from './TableDefaultFilter';
import { Button, Circle, DropDown } from '@wajeez-web/components/ui';
import { TableFiltersProps, ColumnsTypes } from './types';
import { DropDownItem } from '@wajeez-web/components/ui';

interface TableHeaderProps extends TableFiltersProps {
  defultFilterscomponents?: JSX.Element[];
  setOpenManageColumnsModal: () => void;
  setShowSideFilters: () => void;
  clearFilter: () => void;
  tableHeaderActions?: (columns: ColumnsTypes[]) => DropDownItem[];
}

const TableHeader: React.FC<TableHeaderProps> = ({
  clearFilter,
  selectedColumnsFilters,
  setSelectedColumnsFilters,
  columns,
  tableData,
  defultFilterscomponents,
  setOpenManageColumnsModal,
  setShowSideFilters,
  tableHeaderActions,
}) => {
  return (
    <div className={`flex justify-between items-center pb-6`}>
      <div className="flex justify-center items-center space-s-2">
        <TableDefaultFilter
          selectedColumnsFilters={selectedColumnsFilters}
          setSelectedColumnsFilters={setSelectedColumnsFilters}
          columns={columns}
          tableData={tableData}
        />
        {defultFilterscomponents?.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
        <Button
          title="Filters"
          Icon={BiFilter}
          prefix={
            selectedColumnsFilters.length ? (
              <Circle value={selectedColumnsFilters.length + ''} />
            ) : null
          }
          shape="circle"
          color="textPrimary"
          bg={
            selectedColumnsFilters.length
              ? 'primary-50'
              : 'white border border-warmGray-200'
          }
          onClick={setShowSideFilters}
        />
        {selectedColumnsFilters.length > 0 && (
          <div
            onClick={() => clearFilter()}
            className="text-primary text-xs cursor-pointer my-auto ms-1 hover:text-primary-light   "
          >
            Clear All
          </div>
        )}
      </div>

      <DropDown
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        list={[
          {
            label: 'Manage Columns',
            type: 'action',
            onClick: () => {
              setOpenManageColumnsModal();
            },
            icon: <BsLayoutThreeColumns className="h-3 w-3 me-1" />,
          },
        ]
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .concat(tableHeaderActions ? tableHeaderActions(columns) : [])}
        Icon={CogIcon}
        name="table_actions"
      />
    </div>
  );
};

export default TableHeader;
